import styled from 'styled-components';
import { colors, breakPoints, mixins } from '@/styles';

export const ImageCell = styled.div`
  display: flex;
  height: 100%;
  padding: 4px;
  & > * {
    display: flex;
    overflow: hidden;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  background: ${colors.secondary.lightGray2};
  border: 1px solid ${colors.secondary.lightGray3};

  align-items: center;
  justify-content: center;
  img.image-thumbnail {
    object-fit: contain;
  }
`;

export const ImageDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ImageContainer = styled.div<{ $proportion?: number }>`
  border: 1px solid ${colors.secondary.lightGray2};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  /* ${mixins.checkedImageBackground}; */

  img {
    max-width: ${(props) => props.$proportion || 100}%;
    max-height: ${(props) => props.$proportion || 100}%;
    object-fit: contain;
  }

  @media (max-width: ${breakPoints.mobile}) {
    width: 100%;
    height: calc(100vw - 40px);
  }
`;
